import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

export type AnzHomePageBannerActionButtonType = 'left' | 'right';

const variantClasses: Record<AnzHomePageBannerActionButtonType, string> = {
  left: 'rounded-tr-[8px] rounded-br-[8px]',
  right: 'rounded-tl-[8px] rounded-bl-[8px]',
};

@Component({
  standalone: true,
  selector: 'button[anz-banner-action-button]',
  styleUrls: ['./homepage-banner-action-button.component.scss'],
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzHomePageBannerActionButtonComponent {
  @HostBinding('class') get buttonClass(): string {
    return [
      'h-20 w-12 bg-[#00416526] box-border border-none',
      'flex items-center justify-center hover:cursor-pointer',
      'active:outline active:outline-2 active:outline-[#5bc6e8] active:bg-[#00416540]',
      'focus:outline focus:outline-2 focus:outline-[#5bc6e8] focus:bg-[#00416540]',
      variantClasses[this.actionButtonType],
    ].join(' ');
  }

  @Input() actionButtonType: AnzHomePageBannerActionButtonType = 'left';
}
